import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap";

import {
    FiHome,
    FiInfo,
    FiPhone,
    FiDollarSign,
    FiShield,
    FiFileText,
    FiCode,
    FiCpu,
    FiDatabase,
    FiLayers,
    FiSettings,
    FiExternalLink,
    FiFolder,
    FiBookOpen,
} from "react-icons/fi";

import "./SEOPage.css";


function SEOPage() {

    const mainPages = [
        {
            name: "Home",
            path: "/",
            icon: <FiHome />,
        },
        {
            name: "About FeesWorth",
            path: "/about",
            icon: <FiInfo />,
        },
        {
            name: "Contact",
            path: "/contact",
            icon: <FiPhone />,
        },
        {
            name: "Fees Structure",
            path: "/fees-structure",
            icon: <FiDollarSign />,
        },
        {
            name: "Privacy Policy",
            path: "/privacy-policy",
            icon: <FiShield />,
        },
        {
            name: "Terms & Conditions",
            path: "/terms-conditions",
            icon: <FiFileText />,
        },
    ];


    const aiCourses = [
        {
            name: "Python Programming Courses",
            path: "/python-courses-pay-after-learn",
            icon: <FiCode />,
        },
        {
            name: "Artificial Intelligence Courses",
            path: "/ai-courses-pay-after-learn",
            icon: <FiCpu />,
        },
        {
            name: "Machine Learning Courses",
            path: "/machine-learning-courses-pay-after-learn",
            icon: <FiDatabase />,
        },
        {
            name: "Data Science Courses",
            path: "/data-science-courses-pay-after-learn",
            icon: <FiLayers />,
        },
        {
            name: "Best Online Courses",
            path: "/best-online-courses",
            icon: <FiBookOpen />,
        },
    ];


    const aiProjects = [
        {
            name: "RAG - Retrieval Augmented Generation",
            path: "/ai-ml-project-rag-retrieval-argument-generation",
            icon: <FiCpu />,
        },
        {
            name: "AI IT Support & Automated Ticketing",
            path: "/replace-it-help-desk-with-automated-ticketing-system-using-ai",
            icon: <FiSettings />,
        },
        {
            name: "Brain Stroke Prediction",
            path: "/ai-ml-project-brain-stroke-prediction-opencv-cnn",
            icon: <FiDatabase />,
        },
        {
            name: "Image Classification",
            path: "/ai-ml-project-image-classification-deep-learning",
            icon: <FiLayers />,
        },
        {
            name: "Intelligent Manufacturing Quality Control",
            path: "/ai-ml-project-intelligent-manufacturing-quality-control-system",
            icon: <FiSettings />,
        },
    ];


    const cadPages = [
        {
            name: "CAD Customization Courses",
            path: "/cad-customization-courses",
            icon: <FiSettings />,
        },
        {
            name: "CAD Automation Training",
            path: "/cad-automation-training",
            icon: <FiSettings />,
        },
    ];


    const cadCourses = [
        {
            name: "NX Open Customization & Automation Training",
            path: "/nx-open-customization-automation-training",
            icon: <FiSettings />,
        },
        {
            name: "CATIA CAA Customization & Automation Training",
            path: "/catia-caa-customization-automation-training",
            icon: <FiSettings />,
        },
        {
            name: "Python CATIA Automation & Customization",
            path: "/python-catia-automation-customization",
            icon: <FiCode />,
        },
        {
            name: "CREO Toolkit Customization Training",
            path: "/creo-toolkit-customization-training",
            icon: <FiSettings />,
        },
        {
            name: "SolidWorks API Customization & Automation",
            path: "/solidworks-api-customization-automation-training",
            icon: <FiSettings />,
        },
        {
            name: "AutoCAD .NET API Automation Training",
            path: "/autocad-api-customization-automation-online-courses",
            icon: <FiCode />,
        },
        {
            name: "Autodesk Revit API Customization & Automation",
            path: "/autodesk-revit-api-customization-automation-course",
            icon: <FiLayers />,
        },
        {
            name: "Autodesk Inventor API Customization & Automation",
            path: "/autodesk-inventor-api-customization-automation-course",
            icon: <FiSettings />,
        },
        {
            name: "Teamcenter PLM Customization",
            path: "/teamcenter-plm-customization-training-itk-rac-soa-awc",
            icon: <FiLayers />,
        },
        {
            name: "PTC Windchill PLM Customization",
            path: "/ptc-windchill-plm-customization-course",
            icon: <FiLayers />,
        },
    ];


    const renderLinks = (links) => {

        return (
            <div className="seo-links">

                {links.map((item) => (

                    <a
                        key={item.path}
                        href={item.path}
                        className="seo-link"
                    >

                        <span className="seo-link-icon">
                            {item.icon}
                        </span>

                        <span className="seo-link-content">

                            <strong>
                                {item.name}
                            </strong>

                            <small>
                                feesworth.com{item.path === "/" ? "" : item.path}
                            </small>

                        </span>

                        <FiExternalLink className="seo-external-icon" />

                    </a>

                ))}

            </div>
        );
    };


    const renderSection = (
        title,
        description,
        icon,
        links
    ) => {

        return (

            <Col
                lg="6"
                md="12"
                className="mb-4"
            >

                <Card className="seo-card">

                    <CardBody>

                        <div className="seo-card-header">

                            <div className="seo-card-icon">
                                {icon}
                            </div>

                            <div>

                                <h2>
                                    {title}
                                </h2>

                                <p>
                                    {description}
                                </p>

                            </div>

                        </div>


                        {renderLinks(links)}

                    </CardBody>

                </Card>

            </Col>

        );
    };


    return (

        <div className="seo-page">

            {/* =====================================================
                HERO
            ===================================================== */}

            <section className="seo-hero">

                <Container>

                    <div className="seo-hero-content">

                        <span className="seo-badge">
                            FeesWorth Website
                        </span>

                        <h1>
                            FeesWorth Sitemap
                        </h1>

                        <p>
                            Explore all courses, training programs,
                            projects and important pages available on
                            FeesWorth.
                        </p>

                    </div>

                </Container>

            </section>


            {/* =====================================================
                LINKS
            ===================================================== */}

            <section className="seo-main">

                <Container>

                    <Row>

                        {renderSection(
                            "Main Pages",
                            "Important FeesWorth website pages.",
                            <FiHome />,
                            mainPages
                        )}


                        {renderSection(
                            "AI & ML Courses",
                            "Artificial Intelligence, Machine Learning and Data Science training.",
                            <FiCpu />,
                            aiCourses
                        )}


                        {renderSection(
                            "AI & ML Projects",
                            "Practical AI and Machine Learning projects.",
                            <FiCode />,
                            aiProjects
                        )}


                        {renderSection(
                            "CAD Training",
                            "CAD customization and automation training programs.",
                            <FiSettings />,
                            cadPages
                        )}


                        <Col
                            lg="12"
                            md="12"
                            className="mb-4"
                        >

                            <Card className="seo-card">

                                <CardBody>

                                    <div className="seo-card-header">

                                        <div className="seo-card-icon">
                                            <FiLayers />
                                        </div>

                                        <div>

                                            <h2>
                                                CAD & PLM Courses
                                            </h2>

                                            <p>
                                                Specialized CAD API,
                                                customization, automation
                                                and PLM training programs.
                                            </p>

                                        </div>

                                    </div>


                                    <div className="seo-course-grid">

                                        {cadCourses.map((item) => (

                                            <a
                                                key={item.path}
                                                href={item.path}
                                                className="seo-link"
                                            >

                                                <span className="seo-link-icon">
                                                    {item.icon}
                                                </span>

                                                <span className="seo-link-content">

                                                    <strong>
                                                        {item.name}
                                                    </strong>

                                                    <small>
                                                        feesworth.com{item.path}
                                                    </small>

                                                </span>

                                                <FiExternalLink className="seo-external-icon" />

                                            </a>

                                        ))}

                                    </div>

                                </CardBody>

                            </Card>

                        </Col>

                    </Row>

                </Container>

            </section>


            {/* =====================================================
                FOOTER INFO
            ===================================================== */}

            <section className="seo-bottom">

                <Container>

                    <div className="seo-bottom-content">

                        <FiFolder />

                        <div>

                            <h3>
                                FeesWorth Course Directory
                            </h3>

                            <p>
                                Browse all available FeesWorth training
                                programs, courses and resources from one
                                place.
                            </p>

                        </div>

                    </div>

                </Container>

            </section>

        </div>
    );
}


export default SEOPage;